import { Button } from 'primereact'
import { useEffect, useState } from 'react'
import Table from '../../components/layout/Table'
import Modal from '../../components/popup/Modal'
import capPhatVanBangProcessor from '../../processor/capPhatVanBangProcessor'
import userProcessor from '../../processor/userProcessor'
import { dateToDDMMYY } from '../../utils/date'

const LichSuCapPhat = (props) => {
  const { id, visible, toggle } = props
  const [users, setUsers] = useState([])
  const [lydo, setLydo] = useState([])

  useEffect(async () => {
    if (id && visible) {
      const rs = await capPhatVanBangProcessor.getLyDoHuy(id)
      setLydo(
        rs.map((item, index) => {
          return { ...item, index: index + 1 }
        }),
      )
    }
  }, [visible])

  useEffect(async () => {
    const rs = await userProcessor.getAll()
    setUsers(rs)
  }, [])

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button label="Huỷ" className="p-button-secondary mr-2" onClick={toggle} />
    </div>
  )
  const columnTable = [
    {
      value: 'index',
      name: 'Lần cấp',
    },
    {
      value: 'dateCapPhat',
      name: 'Thời gian',
      render: (data) => data.ngayCapPhat && dateToDDMMYY(new Date(data.ngayCapPhat)),
    },
    {
      value: 'nguoiCapPhatId',
      name: 'Người cấp phát',
      render: (data) => {
        const user = users.find((item) => item.id === data.nguoiThucHien)
        return user && user.fullname
      },
    },
    {
      value: 'dateHuy',
      name: 'Thời gian',
      render: (data) => data.ngayHuy && dateToDDMMYY(new Date(data.ngayHuy)),
    },
    {
      value: 'nguoiHuyId',
      name: 'Người huỷ',
      render: (data) => {
        const user = users.find((item) => item.id === data.nguoiThucHienHuy)
        return user && user.fullname
      },
    },
    { value: 'lyDo', name: 'Lý do' },
  ]
  return (
    <Modal width="80%" visible={visible} toggle={toggle} footer={footer}>
      <Table data={lydo} column={columnTable} />
    </Modal>
  )
}

export default LichSuCapPhat
